<div class="modal-full-page-body">
  <h1 class="title">Create {{ formModel.accountType | titlecase }} Business Account</h1>

  <div class="form" [class.form-with-error]="formSubmitError">
    <form [formGroup]="businessAccountTypeForm" class="mb-5">
      <rkt-form
        [form]="businessAccountTypeForm"
        [fields]="businessAccountTypeFields"
        [model]="formModel"
        (modelChange)="onTypeModelChange($event)"
      ></rkt-form>
    </form>

    @if (formModel.accountType === 'CHILD') {
      <app-form-select-field
        label="Parent Business Account"
        placeholder="Select a Parent Business Account"
        class="mb-5"
        [required]="true"
        [items]="parentBusinessAccountListItems"
        [loading]="parentBusinessAccountListLoading"
        (changed)="parentBusinessAccountId = $event"
        (scrolledToEnd)="onParentBusinessAccountSelectScrollToEnd()"
      ></app-form-select-field>
    }

    <form [formGroup]="businessAccountForm" class="mb-5">
      <rkt-form [form]="businessAccountForm" [fields]="createBusinessAccountFields" [model]="formModel"></rkt-form>
    </form>

    <form [formGroup]="businessAccountAdditionalForm">
      <rkt-form
        [form]="businessAccountAdditionalForm"
        [fields]="createBusinessAccountAdditionalFields"
        [model]="formModel"
        (modelChange)="modelChange($event)"
      ></rkt-form>
    </form>

    <div class="separator"></div>
    <h1 class="title">Contact Person Information</h1>
    <form [formGroup]="businessAccountAdditionalForm">
      <rkt-form [form]="businessAccountAdditionalForm" [fields]="createBusinessAccountContactPersonFields" [model]="formModel"></rkt-form>
    </form>
    <div class="separator"></div>

    <app-address-add
      type="PHYSICAL"
      [isRequired]="true"
      (changed)="setAddresses($event, 'physicalAddresses')"
      (isFormInvalid)="addressFormValidity['PHYSICAL'] = $event"
    />

    <div class="separator"></div>

    <app-address-add
      type="MAILING"
      (changed)="setAddresses($event, 'mailingAddresses')"
      (isFormInvalid)="addressFormValidity['MAILING'] = $event"
    />

    <div class="separator"></div>

    <app-address-add
      type="SHIPPING"
      (changed)="setAddresses($event, 'shippingAddresses')"
      (isFormInvalid)="addressFormValidity['SHIPPING'] = $event"
    />
  </div>

  @if (formSubmitError) {
    <div class="error-container">
      <div class="separator"></div>
      <div class="details-page-edit-form-error">{{ formSubmitError }}</div>
    </div>
  }

  <div class="footer">
    <div class="separator"></div>
    <div class="buttons">
      <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>

      <button
        rktButton
        type="submit"
        (click)="onSubmit()"
        [title]="'Add ' + (formModel.accountType | titlecase) + ' Account'"
        [disabled]="
          businessAccountForm.invalid ||
          businessAccountAdditionalForm.invalid ||
          isSomeAddressFormInvalid ||
          (formModel.accountType === 'CHILD' && !parentBusinessAccountId) ||
          isLoading
        "
      >
        Add {{ formModel.accountType | titlecase }} Business Account
      </button>
    </div>
  </div>
</div>
